// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manage--wrapper {\n  background: #fefefe;\n  border-radius: 2px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.manage--wrapper > h1 {\n  font-size: 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
